export function parsePDFPrintOptions(paramObj) {
    const defaults = {
        fileName: "data",
        countingTableIndex: -1,
        rowCountPerPage: 27,
        marginTopBottom: 10,
        marginLeftRight: 10,
        mmWidth: 210,
        isLandscape: false,
        hasTotalRow: false,
        trTdClass: "",
        originPrintLogic: false,
    };
    if (typeof paramObj !== "object" || paramObj === null)
        return defaults;
    return {
        fileName: paramObj.fileName || defaults.fileName,
        countingTableIndex: paramObj.countingTableIndex || defaults.countingTableIndex,
        rowCountPerPage: paramObj.rowCountPerPage || defaults.rowCountPerPage,
        marginTopBottom: paramObj.marginTopBottom || defaults.marginTopBottom,
        marginLeftRight: paramObj.marginLeftRight || defaults.marginLeftRight,
        mmWidth: paramObj.mmWidth || defaults.mmWidth,
        isLandscape: paramObj.isLandscape || defaults.isLandscape,
        hasTotalRow: paramObj.hasTotalRow || defaults.hasTotalRow,
        trTdClass: paramObj.trTdClass || defaults.trTdClass,
        originPrintLogic: paramObj.originPrintLogic || defaults.originPrintLogic,
    };
}
